import { atom } from "recoil";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceInfoState = atom<any>({
    key: "user-device-info-state",
    default: null
})